import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ButtonProps } from '@/ui/button'
import { useWallet } from './use-wallet'

export type WalletConnectButtonProps = Omit<
  ButtonProps,
  'onClick' | 'disabled'
> & {
  disabled?: boolean
  showConnectionState?: boolean
}

/**
 * Кнопка подключения TON кошелька
 * Следует документации: https://docs.ton.org/v3/guidelines/ton-connect/frameworks/react
 */
const WalletConnectButton = forwardRef<
  HTMLButtonElement,
  WalletConnectButtonProps
>(({ children, disabled, showConnectionState = false, ...props }, ref) => {
  const { t } = useTranslation('app')
  const { isConnected, isVerifying, connect } = useWallet()

  const isDisabled = disabled || isVerifying || isConnected

  const getButtonText = () => {
    if (!showConnectionState) {
      return children
    }

    if (isConnected) {
      return t('wallet_connect.connected')
    }

    if (isVerifying) {
      return t('wallet_connect.checking')
    }

    return children || t('wallet_connect.connect_button')
  }

  return (
    <Button ref={ref} {...props} onClick={connect} disabled={isDisabled}>
      {getButtonText()}
    </Button>
  )
})

WalletConnectButton.displayName = 'WalletConnectButton'

export { WalletConnectButton }
